if (!customElements.get("m-buy-with-confidence")) {
  class MBuyWithConfidence extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this._navAbort = null;
      this._mq = window.matchMedia("(max-width: 989px)");
      this._onMq = () => this._syncSwiper();
      this._onSectionLoad = (e) => {
        if (e.detail && e.detail.sectionId === this.dataset.sectionId) {
          this._destroySwiper();
          this._syncSwiper();
        }
      };
      this._onBlockSelect = (e) => this._handleBlockSelect(e);
      this._updateNavState = () => this._applyNavState();
    }

    connectedCallback() {
      this._mq.addEventListener("change", this._onMq);
      document.addEventListener("shopify:section:load", this._onSectionLoad);
      document.addEventListener("shopify:block:select", this._onBlockSelect);
      this._syncSwiper();
    }

    disconnectedCallback() {
      this._mq.removeEventListener("change", this._onMq);
      document.removeEventListener("shopify:section:load", this._onSectionLoad);
      document.removeEventListener("shopify:block:select", this._onBlockSelect);
      this._destroySwiper();
    }

    _syncSwiper() {
      if (this._mq.matches) {
        this._initSwiperWhenReady();
      } else {
        this._destroySwiper();
      }
    }

    _applyNavState() {
      const prev = this.querySelector(".bwc__btn--prev");
      const next = this.querySelector(".bwc__btn--next");
      if (!prev || !next) return;

      if (!this.swiper) {
        prev.classList.remove("is-disabled");
        next.classList.remove("is-disabled");
        prev.removeAttribute("aria-disabled");
        next.removeAttribute("aria-disabled");
        return;
      }

      const atStart = this.swiper.isBeginning;
      const atEnd = this.swiper.isEnd;

      prev.classList.toggle("is-disabled", atStart);
      next.classList.toggle("is-disabled", atEnd);
      if (atStart) prev.setAttribute("aria-disabled", "true");
      else prev.removeAttribute("aria-disabled");
      if (atEnd) next.setAttribute("aria-disabled", "true");
      else next.removeAttribute("aria-disabled");
    }

    _initSwiperWhenReady() {
      if (this.swiper) return;
      this._loadAttempts = (this._loadAttempts || 0) + 1;
      if (this._loadAttempts > 50) return;
      if (typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) {
        setTimeout(() => this._mq.matches && this._initSwiperWhenReady(), 50);
        return;
      }

      const container = this.querySelector(".bwc__swiper");
      if (!container) return;

      const paginationEl = this.querySelector(".bwc__pagination");
      const prevEl = this.querySelector(".bwc__btn--prev");
      const nextEl = this.querySelector(".bwc__btn--next");
      const gap = Math.max(8, parseInt(this.dataset.slideGap, 10) || 20);

      if (this._navAbort) {
        this._navAbort.abort();
      }
      this._navAbort = new AbortController();
      const { signal } = this._navAbort;

      this.swiper = new MinimogLibs.Swiper(container, {
        speed: 400,
        slidesPerView: 1,
        spaceBetween: gap,
        watchOverflow: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              type: "bullets",
            }
          : false,
      });

      if (prevEl) {
        prevEl.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            if (!this.swiper || this.swiper.isBeginning) return;
            this.swiper.slidePrev();
          },
          { signal }
        );
      }
      if (nextEl) {
        nextEl.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            if (!this.swiper || this.swiper.isEnd) return;
            this.swiper.slideNext();
          },
          { signal }
        );
      }

      this.swiper.on("slideChange", this._updateNavState);
      this.swiper.on("reachBeginning", this._updateNavState);
      this.swiper.on("reachEnd", this._updateNavState);
      this._applyNavState();
    }

    _destroySwiper() {
      if (this._navAbort) {
        this._navAbort.abort();
        this._navAbort = null;
      }
      if (this.swiper) {
        try {
          this.swiper.off("slideChange", this._updateNavState);
          this.swiper.off("reachBeginning", this._updateNavState);
          this.swiper.off("reachEnd", this._updateNavState);
        } catch (_) {}
        try {
          this.swiper.destroy(true, true);
        } catch (_) {}
        this.swiper = null;
      }
      this._loadAttempts = 0;
      this._applyNavState();
    }

    _handleBlockSelect(evt) {
      const blockId = evt.detail && evt.detail.blockId;
      if (!blockId) return;
      const blockEl = this.querySelector(`#shopify-block-${blockId}`);
      if (!blockEl || !this.contains(blockEl)) return;
      const slide = blockEl.classList.contains("swiper-slide")
        ? blockEl
        : blockEl.closest(".swiper-slide");
      if (this.swiper && slide) {
        const idx = Number(slide.dataset.index);
        if (!Number.isNaN(idx)) this.swiper.slideTo(idx);
        this._applyNavState();
      } else if (blockEl) {
        blockEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }

  customElements.define("m-buy-with-confidence", MBuyWithConfidence);
}
